<template>
    <div class="monitoring-search">
        <WBInput class="monitoring-search__input" placeholder="Поиск по проектам" />
        <UiButton class="monitoring-search__button">
            <span class="monitoring-search__button-label _desktop">Поиск</span>
            <WBIcon class="monitoring-search__button-icon _mobile" name="search" />
        </UiButton>
    </div>
</template>

<script setup></script>

<style lang="scss" scoped>
    .monitoring-search {
        display: flex;
        align-items: center;
        flex: 1 0 auto;

        &__button {
            &-label {
                @include respond-to(mobile) {
                    display: none;
                }
            }

            &-icon {
                display: none;

                @include respond-to(mobile) {
                    display: flex;
                    width: 16px;
                    height: 16px;
                }
            }

            @include respond-to(mobile) {
                padding: 12px;
                border-radius: 50%;
            }
        }

        &__input {
            width: 100%;
            max-width: 592px;
            margin-right: 12px;

            @include respond-to(mobile) {
                max-width:100%;
                margin-right: 8px;
            }
        }
    }
</style>
